// extracted by mini-css-extract-plugin
export const phoneNumberContainer = "PhoneNumber-module--phone-number-container--3Z6kR";
export const phoneDisclaimer = "PhoneNumber-module--phone-disclaimer--37j0A";
export const forcePhoneDisclaimerShow = "PhoneNumber-module--force-phone-disclaimer-show--Y3UxN";
export const phoneNumber = "PhoneNumber-module--phone-number--376v6";
export const clickToCallButton = "PhoneNumber-module--click-to-call-button--kaoaG";
export const phoneNumberAlt = "PhoneNumber-module--phone-number-alt--1DP4E";
export const phoneNumberIcon = "PhoneNumber-module--phone-number-icon--3DOUJ";